import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    contributions: {
      current: null,
      goal: null
    }
  },
  mutations: {
    setContributions(state, payload) {
      state.contributions = payload;
    }
  },
  actions: {
    loadAll: async ({ commit }) => {
      let contributionData = await api.get(`general/settings`);
      commit("setContributions", contributionData.data.contributions);
    },
    save: async ({ dispatch }, formData) => {
      await api.put(`general/settings`, formData);
      dispatch("loadAll");
    }
  },
  getters: {
    contributions(state) {
      return state.contributions;
    }
  }
};
